import moment from 'moment'

export function insertGridDateExtraData (data) {
  const { state, gridId, cellKey } = data
  const dataGrids = state.models_dashboardModel

  for (let rowKey in dataGrids[gridId]) {
    const row = dataGrids[gridId][rowKey]

    delete row[`$${cellKey}$display`]
    delete row[`$${cellKey}$MonthYear`]
    delete row[`$${cellKey}$Month`]
    delete row[`$${cellKey}$Year`]
    delete row[`$${cellKey}$Date`]
    delete row[`$${cellKey}$YearWeek`]

    if (!row[cellKey]) continue

    row[`$${cellKey}$display`] = moment(row[cellKey]).format(state.dashboardSettings.regional.date)

    //year month
    row[`$${cellKey}$MonthYear`] = moment(row[cellKey]).format('MMMM') + ' ' +  moment(row[cellKey]).format('YYYY')
    //month
    row[`$${cellKey}$Month`] = moment(row[cellKey]).format('MMMM')
    //year
    row[`$${cellKey}$Year`] = moment(row[cellKey]).format('YYYY')
    //date
    row[`$${cellKey}$Date`] = moment(row[cellKey]).format('l')
    //week
    row[`$${cellKey}$YearWeek`] = moment(row[cellKey]).format('gg') + '/'+ moment(row[cellKey]).format('WW')
  }
}

export function insertCellDateExtraData (data) {
  const { state, gridId, rowKey, cellKey } = data
  const row = state.models_dashboardModel[gridId][rowKey]

  delete row[`$${cellKey}$display`]
  delete row[`$${cellKey}$MonthYear`]
  delete row[`$${cellKey}$Month`]
  delete row[`$${cellKey}$Year`]
  delete row[`$${cellKey}$Date`]
  delete row[`$${cellKey}$YearWeek`]

  if (!row[cellKey]) return

  const $display = moment(row[cellKey]).format(state.dashboardSettings.regional.date)
  row[`$${cellKey}$display`] = $display

  //year month
  const $MonthYear = moment(row[cellKey]).format('MMMM') + ' ' +  moment(row[cellKey]).format('YYYY')
  row[`$${cellKey}$MonthYear`] = $MonthYear
  //month
  const $Month = moment(row[cellKey]).format('MMMM')
  row[`$${cellKey}$Month`] = $Month
  //year
  const $Year = moment(row[cellKey]).format('YYYY')
  row[`$${cellKey}$Year`] = $Year
  //date
  const $Date = moment(row[cellKey]).format('l')
  row[`$${cellKey}$Date`] = $Date
  //week
  const $YearWeek = moment(row[cellKey]).format('gg') + '/'+ moment(row[cellKey]).format('WW')
  row[`$${cellKey}$YearWeek`] = $YearWeek
}
